import { ADD_TAGS_SUCCESS, ADD_TAGS_REQUEST, ADD_TAGS_FAILURE, ADD_TAGS_RESET } from "@/redux/actions";
const initialState = {
    data: null,
    loading: false,
    error: null,
};
const addTagsReducer = (state = initialState, action) => {
    switch (action.type) {
        case ADD_TAGS_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, data: action.payload });
        case ADD_TAGS_REQUEST:
            return Object.assign({}, state);
        case ADD_TAGS_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload });
        case ADD_TAGS_RESET:
            return Object.assign(Object.assign({}, state), { loading: false, data: null, error: null });
        default:
            return state;
    }
};
export default addTagsReducer;
